import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper
  },
  selectArea: {
    borderRadius: 4,
    backgroundColor: 'lightgray',
    borderColor: 'gray',
    borderWidth: 1,
    border: 'solid',
    width: '100%'
  },
  selected: {
    backgroundColor: 'white'
  },
  tabArea: {
    padding: 10,
    backgroundColor: '#e0e0e0'
  },
  progressArea: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    justifyItems: 'center',
    flexDirection: 'column'
  },
  buttonArea: {
    paddingRight: '10px',
    flex: 1,
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center'
  }
}))

export default useStyles
